import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import { getFulfillmentOrdersApi } from './getFulfillmentOrders.api'
import { getFulfillmentOrdersInitialState } from './getFulfillmentOrders.initialState'
import { GetFulfillmentOrdersErrorResponse, GetFulfillmentOrdersRequestPayload } from './getFulfillmentOrders.types'

export const getFulfillmentOrders = createAsyncThunk(
  urls.fulfillmentOrders.getFulfillmentOrders,
  async (payload: GetFulfillmentOrdersRequestPayload, { rejectWithValue }) => {
    try {
      const response = await getFulfillmentOrdersApi(payload.request)

      if (payload.onSuccess) {
        payload.onSuccess()
      }

      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

const getFulfillmentOrdersSlice = createSlice({
  name: urls.fulfillmentOrders.getFulfillmentOrders,
  initialState: getFulfillmentOrdersInitialState,
  reducers: {
    resetGetFulfillmentOrders: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFulfillmentOrders.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getFulfillmentOrders.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getFulfillmentOrders.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetFulfillmentOrdersErrorResponse
        state.success = null
      })
  }
})

export const { actions: getFulfillmentOrdersActions, reducer: getFulfillmentOrdersReducer } = getFulfillmentOrdersSlice
export const { resetGetFulfillmentOrders } = getFulfillmentOrdersActions
export default getFulfillmentOrdersSlice.reducer
